export default __webpack_public_path__ + "static/Hero-2f5ecf727f283b03d047985fe2ed5769.webp";